import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { FC } from 'react';
import { PrestationFields, ResourceSections, WizardLayout } from '../shared/components';
import {
  NO_AVAILABLE_SERVICE_MESSAGE,
  NO_CONSULTANT_MESSAGE,
  PAGE_TITLE,
  TOTAL_STEPS,
} from './constants';
import { useStyles } from './styles';
import { useAddPrestation } from './useAddPrestation';

const AddPrestation: FC = () => {
  const classes = useStyles();
  const page = useAddPrestation();

  const nextDisabled = page.submitting || page.loadingUser || !page.canGoNext;

  return (
    <WizardLayout
      classes={classes}
      backLabel="← Retour au profil"
      onBack={page.goToPrestationsTab}
      title={`${PAGE_TITLE}${page.beneficiaryFullName ? ` — ${page.beneficiaryFullName}` : ''}`}
      step={page.step}
      totalSteps={TOTAL_STEPS}
      loading={page.loadingUser}
      bodyClassName={clsx(classes.body, page.step === 1 && classes.bodyNarrow)}
      footerClassName={classes.footer}
      footer={
        <>
          <Button className={classes.secondaryBtn} onClick={page.goPrevious}>
            ← Précédent
          </Button>
          {page.step === 1 && (
            <Button className={classes.primaryBtn} disabled={nextDisabled} onClick={page.goNext}>
              Suivant →
            </Button>
          )}
          {page.step === 2 && (
            <Button
              className={classes.primaryBtn}
              disabled={page.submitting}
              onClick={page.handleSubmit}>
              {page.submitting ? 'Enregistrement...' : 'Enregistrer'}
            </Button>
          )}
        </>
      }>
      {page.step === 1 && (
        <PrestationFields
          consultants={page.consultants}
          consultantId={page.consultantId}
          lockConsultant={page.lockConsultant}
          disableConsultantWhenEmpty={true}
          onConsultantChange={page.setConsultantId}
          consultantWarning={page.consultants.length === 0 ? NO_CONSULTANT_MESSAGE : undefined}
          services={page.availableServices}
          serviceId={page.serviceId}
          onServiceChange={page.setServiceId}
          attachedServiceIds={page.alreadyAttachedServiceIds}
          disableServiceWhenNoneSelectable={true}
          serviceWarning={
            page.consultantId && page.availableServices.length === 0
              ? NO_AVAILABLE_SERVICE_MESSAGE
              : undefined
          }
        />
      )}
      {page.step === 2 && (
        <ResourceSections
          loading={page.loadingCatalogs}
          heading="Ressources"
          emptyHint="Aucune ressource liée à cette prestation."
          sections={[
            {
              kind: 'majorTests',
              catalog: page.majorCatalog,
              selected: page.majorTests,
            },
            {
              kind: 'minorTests',
              catalog: page.minorCatalog,
              selected: page.minorTests,
            },
            {
              kind: 'games',
              catalog: page.gameCatalog,
              selected: page.games,
            },
            {
              kind: 'books',
              catalog: page.bookCatalog,
              selected: page.books,
            },
            {
              kind: 'ebooks',
              catalog: page.ebookCatalog,
              selected: page.ebooks,
            },
          ]}
          onToggle={page.toggleResource}
          onRemove={page.removeResource}
        />
      )}
    </WizardLayout>
  );
};

export default AddPrestation;
